import React, {useState} from 'react';
import {Box, Button, Container, TextField, Typography} from '@mui/material';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import CustomAppBar from '../components/appbar';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import AboutUsCard from '../components/aboutUsCard';
import StatCard from '../components/statCards';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import { PrivacyTipRounded } from '@mui/icons-material';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  ...theme.applyStyles('dark', {
    backgroundColor: '#1A2027',
  }),
}));

const MainPage = () => {
    const navigate = useNavigate();
    return (
        <Box>
            <CustomAppBar active="about"/>
            <Grid container spacing={2} sx={{padding: 2}}>
            <Grid item xs={12} sm = {12} md={8}>
                <AboutUsCard/>
            </Grid>
            <Grid item xs={12} sm={12} md={4}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mx: "auto" }}>
                <StatCard 
                    title="Active Bids" 
                    value="3" 
                    // percentage={1} 
                    icon={() =>
                    <NotificationsActiveIcon sx={{ fontSize: 25, color: '#000' }} />}
                    onClick={()=>navigate('/active-bids')}
                    contents={
                        "Currently open Requests for Proposals (RFPs) that vendors can respond to. " +
                        "These are publicly visible opportunities with active deadlines. " +
                        "Monitor these regularly for new business opportunities."
                    } 
                />

                <StatCard 
                    title="Archived Bids" 
                    value="0" 
                    percentage={1} 
                    icon={() => <span role="img"><Inventory2Icon/></span>} 
                    // color="#FF474D" 
                    contents={
                        "Completed or expired bidding opportunities. " +
                        "These include both awarded and unawarded contracts. " +
                        "Use this archive for market research and to understand past procurement trends."
                    }
                />

                <StatCard 
                    title="Private Bids" 
                    value="0" 
                    percentage={-1} 
                    icon={() => <span role="img"><PrivacyTipRounded/></span>} 
                    // color="#ADD8E6" 
                    contents={
                        "Invitation-only procurement opportunities. " +
                        "These are typically sent to pre-qualified vendors based on specific expertise. " +
                        "Ensure your profile is complete to be considered for private bids."
                    }
                />
            </Box>
            </Grid>
            </Grid>
        </Box>
    );
}

export default MainPage;